import turfDistance from '@turf/distance';
import { point } from '@turf/helpers';
import timezoneList from 'timezone-list';
import timezoneData from 'timezone-list/lib/data.json';
function getTimezoneForPosition(position) {
  if (!position) {
    return 'America/New_York';
  }
  const here = point([position.lon, position.lat]);
  let shortestDistance = Number.MAX_SAFE_INTEGER;
  let nearestZone = 'America/New_York';
  const zoneNames = timezoneList.getZoneByCountry('United States');
  zoneNames.forEach(zoneName => {
    const zones = timezoneData.zones;
    const zone = zones[zoneName];
    const zonePosition = point([zone.long, zone.lat]);
    const distance = turfDistance(here, zonePosition, {
      units: 'miles'
    });
    if (distance < shortestDistance) {
      shortestDistance = distance;
      nearestZone = zoneName;
    }
  });
  return nearestZone;
}
export default {
  getTimezoneForPosition
};